import { ministryIdForApi } from "./ministryContext";
import { api } from "./axios";
import type { PaginatedAttendance } from "@/types/attendance";

export async function getAttendanceRecords(
  churchId: string,
  page = 1,
  pageSize = 25,
): Promise<PaginatedAttendance> {
  const response = await api.get(`/api/churches/${churchId}/attendance`, {
    params: {
      page,
      page_size: pageSize,
    },
  });

  return response.data;
}
export type AttendanceOccurrence = Pick<import("@/types/service").ServiceOccurrence,
  "id" | "title" | "service_type" | "starts_at" | "status">;

export async function getAttendanceOccurrences(churchId: string, ministryId?: string): Promise<AttendanceOccurrence[]> {
  const response = await api.get(`/api/churches/${churchId}/attendance/occurrences`, {
    params: { ministry_id: ministryIdForApi(ministryId) },
  });
  return response.data;
}
